// Live/predictive search. Fetcht een gerenderde Liquid-section
// (sections/predictive-search.liquid) via /search/suggest?section_id=...
// en injecteert de HTML in de header-dropdown.
(() => {
  const forms = document.querySelectorAll('[data-predictive-search]');
  if (!forms.length) return;

  const MIN_CHARS = 2;
  const DEBOUNCE = 200;
  // Ruimer opvragen dan er getoond wordt: de sectie zeeft uitverkochte,
  // verborgen en niet-getrackte producten er pas bij het renderen uit.
  const LIMIT = 8;

  forms.forEach((form) => {
    const input = form.querySelector('[data-predictive-input]');
    const panel = form.querySelector('[data-predictive-results]');
    const baseUrl = form.getAttribute('data-predictive-url') || '/search/suggest';
    if (!input || !panel) return;

    let controller = null;
    let timer = null;
    let activeIndex = -1;

    const open = () => {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    };

    // Eén stop per kaart: een rijke productkaart bevat vier links (media, titel,
    // verlanglijst, quick-add) en zou de pijltjesnavigatie onbruikbaar maken.
    const items = () =>
      Array.from(panel.querySelectorAll('[data-psr-nav], [data-psr-card]'))
        .map((el) => (el.matches('[data-psr-card]') ? el.querySelector('a') : el))
        // Op smalle schermen valt de derde kaart weg via CSS; een verborgen
        // element heeft geen offsetParent en hoort niet in de navigatie.
        .filter((el) => el && el.offsetParent !== null);

    const search = async (query) => {
      if (controller) controller.abort();
      controller = new AbortController();

      const params = new URLSearchParams();
      params.set('q', query);
      params.set('section_id', 'predictive-search');
      params.append('resources[type]', 'product,collection,article,page');
      params.set('resources[limit]', String(LIMIT));
      params.set('resources[options][unavailable_products]', 'last');

      try {
        const res = await fetch(`${baseUrl}?${params.toString()}`, {
          signal: controller.signal,
          headers: { Accept: 'text/html' },
        });
        if (!res.ok) { close(); return; }
        const html = await res.text();
        panel.innerHTML = html.trim();
        activeIndex = -1;
        if (panel.innerHTML) { open(); } else { close(); }
      } catch (err) {
        if (err.name !== 'AbortError') close();
      }
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();
      clearTimeout(timer);
      if (query.length < MIN_CHARS) { close(); return; }
      timer = setTimeout(() => search(query), DEBOUNCE);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= MIN_CHARS && panel.innerHTML) open();
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { close(); input.blur(); return; }
      if (panel.hidden) return;
      const list = items();
      if (!list.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = (activeIndex + 1) % list.length;
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = (activeIndex - 1 + list.length) % list.length;
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0) { e.preventDefault(); list[activeIndex].click(); }
        return;
      } else {
        return;
      }
      list.forEach((a, i) => a.classList.toggle('is-active', i === activeIndex));
      list[activeIndex]?.scrollIntoView({ block: 'nearest' });
    });

    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) close();
    });
  });
})();
